import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'UI';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  MainContainer,
} from './style';

const Extra = (): JSX.Element => {
  const breadcrumbNavigator = useBreadcrumbNavigation();
  const { url } = useRouteMatch();

  return (
    <MainContainer>
      <Button
        icon={<PlusOutlined />}
        onClick={() => breadcrumbNavigator.push({
          url: `${url}${ROUTES.orders.new.root}`,
          label: 'Novo pedido',
        })}
      >
        Novo
      </Button>
    </MainContainer>
  );
};

export default Extra;
